/* @flow */

export default class EligibilityQuestionnaireResult {
  hasAnsweredEveryQuestions: boolean;
  isEligible: boolean;
  ineligibleReasonIds: number[];
}
